import { inject, Injectable } from '@angular/core';
import { HomeFeedSection, HomeFeedService } from '@brightside-web/desktop/feature/home-feed';
import { MpapInitialCardComponent } from './cards/mpap/mpap-initial-card/mpap-initial-card.component';
import { MpapPendingCardComponent } from './cards/mpap/mpap-pending-card/mpap-pending-card.component';
import { ServiceInventoryService, ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { filter, Subscription, tap } from 'rxjs';
import {
  HelpingHandsInitialCardComponent
} from './cards/helping-hands/helping-hands-initial-card/helping-hands-initial-card.component';
import {
  HelpingHandsUploadCardComponent
} from './cards/helping-hands/helping-hands-upload-card/helping-hands-upload-card.component';

@Injectable({
  providedIn: 'root'
})
export class ProgramCardsService {
  private _homeFeedService = inject(HomeFeedService);
  private _serviceInventory = inject(ServiceInventoryService);
  private _sub = new Subscription();

  constructor() {
    this._sub.add(
      this._serviceInventory.getService('mpap')
        .pipe(
          filter((service) => !!service),
          tap((service) => {
            switch (service.state) {
              case ServiceState.INITIAL:
                this.registerMpapInitialCard();
                break;
              case ServiceState.PENDING:
              case ServiceState.UPLOAD:
                this.registerMpapPendingCard(service.route || '', service.state);
                break;
            }
          })
        ).subscribe()
    )
    this._sub.add(
      this._serviceInventory.getService('helping_hands')
        .pipe(
          filter((service) => !!service),
          tap((service) => {
            switch (service.state) {
              case ServiceState.INITIAL:
                this.registerHelpingHandsInitialCard();
                break;
              case ServiceState.UPLOAD:
                this.registerHelpingHandsUploadCard(service.route || '', service.state);
                break;
            }
          })
        ).subscribe()
    )
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }

  private registerMpapInitialCard() {
    this._homeFeedService.registerHomeFeedCard({
      key: 'mpap',
      component: 'MpapInitialCardComponent',
      componentRef: MpapInitialCardComponent,
      data: null,
      order: 1,
      section: HomeFeedSection.PROGRAMS
    });
  }

  private registerMpapPendingCard(route: string, state: string) {
    this._homeFeedService.registerHomeFeedCard({
      key: 'mpap',
      component: 'MpapPendingCardComponent',
      componentRef: MpapPendingCardComponent,
      data: {route, state},
      order: 10,
      section: HomeFeedSection.ACTIONS
    });
  }

  private registerHelpingHandsInitialCard() {
    this._homeFeedService.registerHomeFeedCard({
      key: 'helping_hands',
      component: 'HelpingHandsInitialCardComponent',
      componentRef: HelpingHandsInitialCardComponent,
      data: null,
      order: 2,
      section: HomeFeedSection.PROGRAMS
    });
  }

  private registerHelpingHandsUploadCard(route: string, state: string) {
    this._homeFeedService.registerHomeFeedCard({
      key: 'helping_hands',
      component: 'HelpingHandsUploadCardComponent',
      componentRef: HelpingHandsUploadCardComponent,
      data: {route, state},
      order: 11,
      section: HomeFeedSection.ACTIONS
    });
  }
}
